export default {
  state: { showAmbientAnimations: true },
  mutations: {
    updateShowAmbientAnimations(state, payload) {
      state.showAmbientAnimations = payload;
    }
  }
};
